import * as Yup from 'yup'

export const AddFoodMenuValidation = Yup.object({
  title: Yup.string().required('Enter Your Title'),
  categoryId: Yup.string().required('Please Select Category '),
  status: Yup.string().required('Please Select Status '),
  type: Yup.string().required('Please Select Type '),
  image: Yup.string().required('Please Upload Image '),
  isCombo: Yup.string().required('isCombo is required'),
})
export const EditFoodMenuValidation = Yup.object({
  title: Yup.string().required('Enter Your Title'),
  categoryId: Yup.string().required('Please Select Category '),
  status: Yup.string().required('Please Select Status '),
  type: Yup.string().required('Please Select Type '),
  isCombo: Yup.string().required('isCombo is required'),
})

const updateFoodmenuValidations = Yup.object({
  title: Yup.string().required('Enter Your Title'),
  original_price: Yup.string().required('Enter Your Original Price'),
  subCategoryId: Yup.string().required('Please Select SubCategory'),
  categoryId: Yup.string().required('Please Select Category '),
  status: Yup.string().required('Please Select Status '),
  type: Yup.string().required('Please Select Type '),
})

export {updateFoodmenuValidations}
